import { TimeHorizon } from '../../AccountOpening.meta';

export const timeHorizonOpts = [
  {
    label: 'Less than a year',
    value: TimeHorizon.Short,
  },
  {
    label: '1-3 years',
    value: TimeHorizon.Average,
  },
  {
    label: 'More than 3 years',
    value: TimeHorizon.Longest,
  },
];
